import React, {Fragment} from "react";
import Builder from 'react-querybuilder';
import Button from "../../../../form/Button";
import Select from "../../../../form/Select";
import TextInput from "../../../../form/TextInput";
import classNames from "classnames";
import { formatQuery } from 'react-querybuilder';
import CheckBox from "../../../../form/CheckBox";
import ValueEditor from "./ValueEditor";
import parseQuery from "./parseQuery";
import unparseQuery from "./unparseQuery";
import Collapse from "../../../../layout/Collapse";
import {optionsTemplate, PersonSelect} from "../../../../../utils/formatters";
import DateTimeInput from "../../../../form/DateTimeInput";

export const fields = [
    {
        name: 'person_id',
        label: 'Személy',
        operators: [
            {
                name: '=',
                label: '='
            },
            {
                name: '!=',
                label: '!='
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="person"
                storeType="remote"
                placeholder="Személy"
                label={false}
                optionsTemplate={PersonSelect}
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'sent',
        label: 'Küldés',
        operators: [
            {
                name: '=',
                label: 'Elküldve'
            },
            {
                name: '!=',
                label: 'Nem küldtük'
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="Newsletter"
                storeType="remote"
                placeholder="Hírlevél"
                label={false}
                optionsTemplate={optionsTemplate("Newsletter")}
                selectedOptionTemplate={(props) => <Fragment>{props[props.labelKey]} <i>(#{props[props.valueKey]})</i></Fragment>}
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'opened',
        label: 'Nyitás',
        operators: [
            {
                name: '=',
                label: 'Nyitotta'
            },
            {
                name: '!=',
                label: 'Nem nyitotta'
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="Newsletter"
                storeType="remote"
                placeholder="Hírlevél"
                label={false}
                optionsTemplate={optionsTemplate("Newsletter")}
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'address.postcode',
        label: 'Irányítószám',
        operators: [
            { name: '=', label: '=' },
            { name: '!=', label: '!=' },
            { name: '<', label: '<' },
            { name: '>', label: '>' },
            { name: '<=', label: '<=' },
            { name: '>=', label: '>=' },
            { name: 'between', label: 'között' },
        ],
        valueEditor: (props) => {
            if (props.operator === "between") {
                const values = JSON.parse(JSON.stringify(Array.isArray(props.value) ? props.value : (props.value ? [props.value, null] : [null, null])));
                return <Fragment>
                    <div className="row">
                        <div className="col-md-6">
                            <TextInput
                                placeholder="1123"
                                label={false}
                                value={(values[0] || null)}
                                saveChanges={(field, value) => {
                                    values[0] = value;
                                    props.handleOnChange(values);
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <TextInput
                                placeholder="2311"
                                label={false}
                                value={(values[1] || null)}
                                saveChanges={(field, value) => {
                                    values[1] = value;
                                    props.handleOnChange(values);
                                }}
                            />
                        </div>
                    </div>
                </Fragment>
            }
            return <TextInput
                placeholder="1123"
                label={false}
                value={props.value}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'email',
        label: 'Email',
        operators: [
            {
                name: '=',
                label: '='
            }
        ],
        valueEditor: (props) => {
            return <TextInput
                placeholder="email@domain.com"
                label={false}
                value={props.value}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'purchaseitem',
        label: 'Termékvásárlás',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="product"
                storeType="remote"
                placeholder="Vonalkód vagy cím"
                label={false}
                optionsTemplate={optionsTemplate("product")}
                value={props.value}
                valueKey="base_product_id"
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'purchaseitem.author',
        label: 'Termékvásárlás (szerző alapján)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="author"
                storeType="remote"
                placeholder="Szerző neve"
                label={false}
                optionsTemplate={optionsTemplate("author")}
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'purchaseitem.category',
        label: 'Termékvásárlás (típus szerint)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="ProductCategory"
                storeType="local"
                placeholder="Termék kategória"
                label={false}
                optionsTemplate={optionsTemplate("ProductCategory")}
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'purchaseitem.series',
        label: 'Termékvásárlás (sorozat szerint)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="series"
                storeType="remote"
                placeholder="Sorozat"
                label={false}
                optionsTemplate={optionsTemplate("series")}
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'purchaseitem.pos',
        label: 'Termékvásárlás (eladási hely szerint)',
        operators: [
            {
                name: '=',
                label: 'Vásárolt'
            },
            {
                name: '!=',
                label: 'Nem Vásárolt'
            },
        ],
        valueEditor: (props) => {
            return <Select
                component="PointOfSale"
                storeType="local"
                placeholder="Eladási hely"
                label={false}
                optionsTemplate={optionsTemplate("PointOfSale")}
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
    {
        name: 'purchaseitem.transaction_date',
        label: 'Termékvásárlás (időpont szerint)',
        operators: [
            { name: '=', label: '=' },
            { name: '!=', label: '!=' },
            { name: '<', label: '<' },
            { name: '>', label: '>' },
            { name: '<=', label: '<=' },
            { name: '>=', label: '>=' },
            { name: 'between', label: 'között' },
        ],
        valueEditor: (props) => {
            if (props.operator === "between") {
                const values = JSON.parse(JSON.stringify(Array.isArray(props.value) ? props.value : (props.value ? [props.value, null] : [null, null])));
                return <Fragment>
                    <div className="row">
                        <div className="col-md-6">
                            <DateTimeInput
                                label={false}
                                value={(values[0] || null)}
                                saveChanges={(field, value) => {
                                    values[0] = value;
                                    props.handleOnChange(values);
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <DateTimeInput
                                label={false}
                                value={(values[1] || null)}
                                saveChanges={(field, value) => {
                                    values[1] = value;
                                    props.handleOnChange(values);
                                }}
                            />
                        </div>
                    </div>
                </Fragment>
            }
            return <DateTimeInput
                label={false}
                value={props.value}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />;
        }
    },
];

const operators = [
    { name: 'null', label: 'is null' },
    { name: 'notNull', label: 'is not null' },
    { name: 'in', label: 'in' },
    { name: 'notIn', label: 'not in' },
    { name: '=', label: '=' },
    { name: '!=', label: '!=' },
    { name: '<', label: '<' },
    { name: '>', label: '>' },
    { name: '<=', label: '<=' },
    { name: '>=', label: '>=' },
    { name: 'contains', label: 'contains' },
    { name: 'beginsWith', label: 'begins with' },
    { name: 'endsWith', label: 'ends with' },
    { name: 'doesNotContain', label: 'does not contain' },
    { name: 'doesNotBeginWith', label: 'does not begin with' },
    { name: 'doesNotEndWith', label: 'does not end with' }
];

const combinators = [
    { name: 'and', label: 'És' },
    { name: 'or', label: 'Vagy' }
];


const controlElements = {
    addGroupAction: (props) => <Button icon={{lib: "fas", name: "layer-group"}} onClick={props.handleOnClick} color="primary">{props.label}</Button>,
    removeGroupAction: (props) => <Button icon={{lib: "fas", name: "trash"}} onClick={props.handleOnClick} color="danger"/>,
    addRuleAction: (props) => <Button icon={{lib: "fas", name: "pencil-ruler"}} onClick={props.handleOnClick} color="primary">{props.label}</Button>,
    removeRuleAction: (props) => <div className="col-md-1"><Button block={true} onClick={props.handleOnClick} color="danger">{props.label}</Button></div>,
    combinatorSelector: (props) => <div className={props.className}><div className="form-group"><Select label={false} storeType="local" options={props.options} labelKey="label" valueKey="name" value={props.value} objectValue={false} saveChanges={(field, value) => props.handleOnChange(value)} /></div></div>,
    fieldSelector: (props) => <div className={props.className}>
        <div className="form-group">
            <Select
                label={false}
                storeType="local"
                options={props.options}
                labelKey="label"
                valueKey="name"
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => props.handleOnChange(value)}
            />
        </div>
    </div>,
    valueEditor: (props) => {
        if (props.fieldData && props.fieldData.valueEditor) {
            const Editor = props.fieldData.valueEditor;
            return <div className={props.className}>
                <div className="form-group">
                    <Editor {...props} />
                </div>
            </div>;
        } else {
            return <div className={props.className}>
                <div className="form-group">
                    <ValueEditor {...props} />
                </div>
            </div>;
        }
    },
    operatorSelector: (props) => <div className={props.className}>
        <div className="form-group">
            <Select
                label={false}
                storeType="local"
                options={(props.fieldData || {}).operators || props.options}
                labelKey="label"
                valueKey="name"
                value={props.value}
                objectValue={false}
                saveChanges={(field, value) => props.handleOnChange(value)} />
        </div>
    </div>,
    notToggle: (props) => <div className="col-md-1"><CheckBox value={props.checked} checked={props.checked} label={props.title} saveChanges={() => {
        props.handleOnChange(!props.checked);
    }} /></div>
};

const controlClassnames = {
    ruleGroup: "",
    header: "",

    rule: "",
    fields: "",
    operators: "",
    value: "",
    removeRule: "",
};

const translations = {
    fields: {
        title: "Mezők",
    },
    operators: {
        title: "Operator",
    },
    value: {
        title: "Érték",
    },
    removeRule: {
        label: "x",
        title: "Mező törlés",
    },
    removeGroup: {
        label: "x",
        title: "Csoport törlés",
    },
    addRule: {
        label: "Mező",
        title: "Mező hozzáadása",
    },
    addGroup: {
        label: "Csoport",
        title: "Csoport hozzáadása",
    },
    combinators: {
        title: "Kapcsolat",
    },
    notToggle: {
        title: "Tagadás",
    }
};

export default class QueryBuilder extends React.Component {
    state = {
        opened: false
    };
    render() {
        const query = this.props.value ? (typeof this.props.value === "string" ? unparseQuery(JSON.parse(this.props.value)) : unparseQuery(JSON.parse(JSON.stringify(this.props.value)))) : {
            combinator: "and",
            not: false,
            rules: []
        };
        if (!query.rules) {
            query.rules = [];
            query.combinator = query.combinator || "and";
            query.not = query.not !== undefined ? query.not : false;
        }
        return (
            <div className="form-group">
                <Button block={true} color="default" onClick={() => this.setState({opened: !this.state.opened})}>
                    Szűrő <span className="caret"/>
                </Button>
                <Collapse collapsed={this.state.opened}>
                    <div>
                        <Builder
                            fields={this.props.fields || fields}
                            query={query}
                            combinators={combinators}
                            operators={operators}
                            onQueryChange={(query) => {
                                this.props.saveChanges(this.props.name, parseQuery(JSON.parse(formatQuery(query, 'json_without_ids'))));
                            }}
                            showCombinatorsBetweenRules={true}
                            showNotToggle={false}
                            controlClassnames={controlClassnames}
                            translations={translations}
                            controlElements={controlElements}
                        />
                    </div>
                </Collapse>
                <div className="clearfix" />
            </div>
        );
    }
}